import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "../../../../../../../api/axios";
import Button from '@mui/material/Button';
import "./retailconfig.scss";

const CategoryTable = () => {
  const [categories, setCategories] = useState([]);
  const [sections, setSections] = useState([]);
  const [popupType, setPopupType] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [mapData, setMapData] = useState({ sectionId: "" });
  const [formData, setFormData] = useState({ name: "", description: "", isActive: 1 });
  
   const business_entity_id = sessionStorage.getItem("configBizEntityId");


  // Fetch categories
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`retail/categories/${business_entity_id}`);
      const formattedData = response.data.map((item) => ({
        ...item,
        isActive: item.is_active,
      }));
      setCategories(formattedData);
      console.log("Formatted Data:", formattedData);

    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };


  const fetchSections = async () => {
    try {
      const response = await axios.get(`/retail/sections/${business_entity_id}`); // Replace with your endpoint
      setSections(response.data);
    } catch (error) {
      console.error("Error fetching sections:", error);
    }
  };

  // Handle add or edit category
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (popupType === "edit") {
        await axios.put(`retail/category`, { ...formData, id: selectedCategory.id });
      } else if (popupType === "add") {
        await axios.post(`retail/category`, { ...formData, businessEntityId: business_entity_id });
      }
      fetchCategories();
      closePopup();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  // Handle delete category
  const [showModal, setShowModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const handleDelete = (id) => {
    setSelectedCategoryId(id);
    setShowModal(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`retail/category/${selectedCategoryId}`);
      fetchCategories();
      setShowModal(false);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };


  const handleMapChange = (e) => {
    const { name, value } = e.target;
    setMapData({ ...mapData, [name]: value });
  };
  // Handle map to section
  const handleMapSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`retail/section-category`, {
        categoryId: selectedCategory.id,
        sectionId: mapData.sectionId,
      });
      console.log("Mapped successfully!");
      closePopup();
    } catch (error) {
      console.error("Error mapping category:", error);
    }
  };


  // Open popup
  const openPopup = (type, category = null) => {
    setPopupType(type);
    setSelectedCategory(category);
    if (type === "edit") {
      setFormData(category);
    } else {
      setFormData({ name: "", description: "", isActive: 1 });
      setMapData({ sectionId: "" });
    }
    if (type === "map") fetchSections();
  };

  // Close popup
  const closePopup = () => {
    setPopupType("");
    setSelectedCategory(null);
    setFormData({ name: "", description: "", isActive: 1 });
    setMapData({ sectionId: "" });
  };
  // Handle search
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  // Form field change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Edit button functionality
  const handleEdit = (category) => {
    setIsEditing(true);
    setFormData(category);
  };


  // Filter categories based on search
  const filteredCategories = categories.filter((cat) =>
    cat.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  console.log("Filtered Categories:", filteredCategories);


  // Table columns
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "name", headerName: "Name", width: 200 },
    { field: "description", headerName: "Description", width: 300 },
    { field: "isActive", headerName: "Active", width: 100 },
    {
      field: "actions",
      headerName: "Actions",
      width: 400,
      renderCell: (params) => (
        <div className="actions"  >
          <Button onClick={() => openPopup("edit", params.row)} style={{ border: "1.5px solid green", borderRadius: "7px", padding: "6px 9px", color: "green", marginRight: "12px" }}>Edit</Button>
          <Button onClick={() => {
            fetchCategorySections(params.row.id)
            openPopup("map", params.row)
          }} style={{ border: "1.5px solid darkblue", borderRadius: "7px", padding: "7px 9px", color: "darkblue", marginRight: "12px" }}>Update Mapping</Button>
          <Button onClick={() => handleDelete(params.row.id)} style={{ border: "1.5px solid red", borderRadius: "7px", padding: "6px 9px", color: "red", marginRight: "12px" }}>Delete</Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    fetchCategories();
  }, []);



  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [mapsections, setMapsections] = useState([]);



  const fetchCategorySections = async (categoryId) => {
    sessionStorage.setItem("sessionId", categoryId);
    try {
      const response = await axios.get(`retail/get-category-sections/${categoryId}`);
      setMapsections(response.data);
      setLoading(false);

    } catch (err) {
      setError("Error fetching sections");
      setLoading(false);
    }
  };



  const handleCheckboxChange = (sectionId) => {
    setMapsections((prevSections) =>
      prevSections.map((section) =>
        section.section_id === sectionId ? { ...section, is_active: section.is_active ? 0 : 1 } : section
      )
    );
  };

  const handlemapSubmit = async () => {
    try {
      const categoryId = sessionStorage.getItem("sessionId");
      await axios.put("retail/update-category-mapping", {
        categoryId,
        sectionMappings: mapsections.map(({ section_id, is_active }) => ({
          sectionId: section_id,
          isActive: is_active,
        })),
      });
      // alert("Category mapping updated successfully!");
      closePopup();
    } catch (err) {
      alert("Error updating mappings");
    }
  };

  return (
    <div className="category-table-container">
      <div className="d-flex mb-4 ">
        <input
          type="text"
          placeholder="Search by category name"
          value={searchQuery}
          onChange={handleSearch}
        />
        <Button variant="contained" onClick={() => openPopup("add")} style={{ backgroundColor: '#4CAF50', color: 'white', marginLeft: '10px', whiteSpace: "nowrap", borderRadius: "10px" }}>Add Category</Button>
      </div>

      <div className="data-grid">
        <DataGrid
          rows={filteredCategories}
          columns={columns}
          pageSize={5}
          autoHeight
          checkboxSelection={false}
        />

      </div>

      {popupType && (
        <div className="popup-overlay">
          <div className="popup">
            {popupType === "add" || popupType === "edit" ? (
              <form onSubmit={handleSubmit}>
                <h2>{popupType === "add" ? "Add Category" : "Edit Category"}</h2>
                <input
                  type="text"
                  name="name"
                  placeholder="Category Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <textarea
                  name="description"
                  placeholder="Description"
                  value={formData.description}
                  onChange={handleChange}

                />
                <div className="d-flex gap-3">
                  <Button type="submit" className="btncat">{popupType === "add" ? "Add" : "Update"}</Button>
                  <Button className="btncat" onClick={closePopup}>
                    cancel
                  </Button>
                </div>
              </form>
            ) : popupType === "map" ? (
              // <form onSubmit={handleMapSubmit}>
              //   <h2>Map Category to Section</h2>
              //   <p>Category: {selectedCategory?.name}</p>
              //   <select
              //     name="sectionId"
              //     value={mapData.sectionId}
              //     onChange={handleMapChange}
              //     required
              //   >
              //     <option value="">Select Section</option>
              //     {sections.map((section) => (
              //       <option key={section.id} value={section.id}>
              //         {section.name}
              //       </option>
              //     ))}
              //   </select>
              //   <button type="submit">Map</button>
              // </form>
              <div>
                <h2 >Update Category Mapping</h2>
                <div className="checkbox-container">
                  {mapsections.map((section) => (
                    <label key={section.section_id}>
                      <input
                        type="checkbox"
                        checked={section.is_active === 1}
                        onChange={() => handleCheckboxChange(section.section_id)}
                      />
                      {section.section_name}
                    </label>
                  ))}
                </div>

                <div className="d-flex gap-3">
                  <Button onClick={handlemapSubmit} className="btncat">Save Changes</Button>
                  <Button className="btncat" onClick={closePopup}>
                    cancel
                  </Button>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      )}

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h3 >Warning!</h3>
            <p style={{ fontSize: "20px", color: "#dc3545" }}>
              Deleting this category will also delete all related SKUs and items. Are you sure you want to proceed?
            </p>
            <div className="d-flex">
              <Button onClick={() => setShowModal(false)}>Cancel</Button>
              <Button onClick={confirmDelete}>OK</Button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryTable;
